import * as React from 'react';

import { defaultPingClient } from '@/api/ping-client';
import type { PingClient } from '@/api/ping-client';

// =============================================================================
// ping-client-context.tsx — Injection du PingClient (DI seam).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut : le StubPingClient (Option B).

// STUB-OK: s0-non-metier — walking-skeleton S0, hors périmètre métier V1 (whitelist §4).
const PingClientContext = React.createContext<PingClient>(defaultPingClient);

export interface PingClientProviderProps {
  client?: PingClient | undefined;
  children: React.ReactNode;
}

export function PingClientProvider({
  client = defaultPingClient,
  children,
}: PingClientProviderProps): React.JSX.Element {
  return (
    <PingClientContext.Provider value={client}>{children}</PingClientContext.Provider>
  );
}

export function usePingClient(): PingClient {
  return React.useContext(PingClientContext);
}
